export default __webpack_public_path__ + "static/media/Linero2.2c69100c.png";